import { forwardRef } from 'react';
import { Input } from './fragments/Input';
import { FormField } from './FormField';

interface InputTextProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  required?: boolean;
  isLoading?: boolean;
}

export const InputText = forwardRef<HTMLInputElement, InputTextProps>(
  ({ label, error, required, className, isLoading, ...props }, ref) => {
    return (
      <FormField
        label={label}
        error={error}
        required={required}
        name={props.name || ''}
      >
        <div className='relative'>
        <Input ref={ref} {...props} />
        {isLoading && (
          <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary"></div>
          </div>
        )}
        </div>
      </FormField>
    );
  }
);
